<template>
  <div class="dropdown-root">
    <div
      class="dropdown-component"
      :style="[{ width: label !== '' ? '100%' : width }, frameStyle]"
    >
      <label
        v-if="label !== '' ? true : false"
        :class="['cust-dropdown-label', disabled ? 'disabled' : '']"
        :style="labelStyle"
        >{{ label }}</label
      >

      <b-dropdown
        :id="id"
        class="cust-dropdown"
        :toggle-class="[
          'cust-dropdown-button',
          errorText ? 'error-border' : '',
        ]"
        menu-class="cust-dropdown-menu"
        :style="[{ width: label !== '' ? width : '100%' }, dropdownStyle]"
        :disabled="disabled"
        no-caret
      >
        <template v-slot:button-content>
          <span
            :class="[
              'cust-button-content',
              value === '' && placeholder !== '' ? 'font-gray' : '',
            ]"
            >{{ buttonContent }}</span
          >
          <img src="~@/assets/images/arrow.svg" v-if="!disabled" />
        </template>

        <b-dropdown-item
          v-for="item in options"
          :key="item.value"
          @click="dropdownClick(item.value)"
          >{{ item.text }}</b-dropdown-item
        >
      </b-dropdown>
    </div>

    <div class="dropdown-error">
      <div class="error" v-if="errorText">{{ errorText }}</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';

Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-item', BDropdownItem);

export default {
  name: 'Dropdown',
  props: {
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: [String],
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    frameStyle: {
      type: Object,
      default: () => {},
    },
    labelStyle: {
      type: Object,
      default: () => {},
    },
    dropdownStyle: {
      type: Object,
      default: () => {},
    },
    errorText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonContent() {
      if (this.value !== '') {
        let index = this.options.findIndex((d) => d.value === this.value);

        if (index !== -1) {
          return this.options[index].text;
        }
      }

      if (this.placeholder !== '') {
        return this.placeholder;
      }

      return '';
    },
  },
  watch: {},
  methods: {
    dropdownClick(value) {
      this.$emit('input', value);
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
};
</script>

<style scoped>
.dropdown-component {
  display: inline-block;
  min-height: 65px;
}

.cust-dropdown-label {
  text-align: center;
  margin-left: 16px;
  color: #b18147;
  font-size: 12px;
  font-weight: bold;
  background-color: #ffffff;
  z-index: 2;
  padding: 0px 3px 0px 3px;
  height: 20px;
  position: absolute;
}

.disabled {
  color: gray;
}

.dropdown-component /deep/ .cust-dropdown-button {
  width: 100%;
  text-align: left;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(70, 70, 70, 0.8);
  border-radius: 4px;
  background-color: #ffffff;
  color: #000000;
  min-height: 56px;
  z-index: 1;
  position: absolute;
  margin-top: -5px;
}

/* focus or active custom css調整 */
.dropdown-component /deep/ .cust-dropdown-button:focus,
.dropdown-component /deep/ .cust-dropdown-button.focus,
.dropdown-component
  /deep/
  .cust-dropdown-button:not(:disabled):not(.disabled):active:focus,
.dropdown-component
  /deep/
  .cust-dropdown-button:not(:disabled):not(.disabled).active:focus,
.dropdown-component /deep/ .show > .cust-dropdown-button.dropdown-toggle:focus {
  -webkit-box-shadow: 0 0 0 0;
  box-shadow: 0 0 0 0;
}

.dropdown-component /deep/ .cust-button-content {
  width: calc(100% - 20px);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.dropdown-component /deep/ .cust-dropdown-button.disabled,
.dropdown-component /deep/ .cust-dropdown-button.disabled:hover {
  border: 1px solid rgba(70, 70, 70, 0.5);
  border-radius: 4px;
  background-color: #ffffff;
  color: #000000;
  cursor: unset;
}

/* focus or active custom css調整 */
.dropdown-component /deep/ .cust-dropdown-button:hover,
.dropdown-component
  /deep/
  .cust-dropdown-button:not(:disabled):not(.disabled):active,
.dropdown-component /deep/ .cust-dropdown.show > .cust-dropdown-button {
  border: 1px solid rgba(70, 70, 70, 0.5);
  border-radius: 4px;
  background-color: #ffffff;
  color: #000000;
}

.dropdown-component /deep/ .cust-dropdown.show > .cust-dropdown-button {
  border-color: rgba(70, 70, 70, 0.8);
}
.dropdown-component /deep/ .cust-button-content.font-gray {
  color: gray;
}

/* dropdown arrow css */
.cust-dropdown > .cust-dropdown-button > img {
  width: 18px;
  transition: all 0.3s;
}

.cust-dropdown.show > .cust-dropdown-button > img {
  transform: rotate(-180deg);
}

.dropdown-component /deep/ .cust-dropdown-menu {
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 0px;
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

.dropdown-component /deep/ .cust-dropdown-menu .dropdown-item.active,
.dropdown-component /deep/ .dropdown-item:active,
.dropdown-component /deep/ .dropdown-item:hover,
.dropdown-component /deep/ .dropdown-item:focus {
  color: #000000;
  text-decoration: none;
  background-color: rgba(216, 216, 216, 0.2);
}
.dropdown-error {
  height: auto;
  min-height: 16px;
  text-align: right;
  word-wrap: break-word;
  bottom: 0;
  position: relative;
}
</style>
